import { ListReasonsCommandInput } from '@amzn/gbsa-helios-typescript-client';

export const reasonKeys = {
  all: ['reasons'] as const,
  list: (input: Partial<ListReasonsCommandInput>) =>
    [
      ...reasonKeys.all,
      'list',
      input.businessUnitId,
      input.category,
      input.divisionName,
      input.activeOnly,
    ] as const,
};
